import Domain from '../../../domain/models/Domain';
import { useWindowSize } from '@leedpulse-monorepo/hooks';
import { Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import { advancedOnRow } from '../../../core/utils/commonUtils';
import { DOMAINS_PAGE_PATH } from '../../pages/domains/DomainsPage';

interface DomainsListProps {
  domains: Domain[];
  loading: boolean;
}

// The page loads every domain and filters them: the table paginates in memory
const DomainsList: React.FC<DomainsListProps> = ({ domains, loading }) => {
  const windowSize = useWindowSize();
  const navigate = useNavigate();

  return (
    <Table
      pagination={{
        defaultPageSize: 20,
        showSizeChanger: true,
        simple: true,
        pageSizeOptions: [20, 50, 100, 200],
        position: ['bottomRight', 'topRight'],
        disabled: loading,
      }}
      loading={loading}
      columns={
        windowSize.width > 576
          ? [
            {
              title: 'Nom',
              dataIndex: 'name',
              key: 'name',
            },
            {
              title: 'Archivé',
              dataIndex: 'archived',
              key: 'archived',
              render: (archived) => archived ? 'Oui' : 'Non',
            }
          ]
          : [
            {
              title: 'Nom',
              dataIndex: 'name',
              key: 'name',
            }
          ]
      }
      rowKey={(record) => record.id}
      dataSource={domains}
      onRow={(record) =>
        advancedOnRow({
          url: `${DOMAINS_PAGE_PATH}/${record.id}`,
          navigate,
          className: 'table-row',
        })
      }
    />
  );
};

export default DomainsList;